module.exports = __webpack_public_path__ + "static/item_font_size-c0742fef87466e67cc604053c37197f5.png";